<div class="content-height d-lg-block d-none">
    <div class="row h-100">
        <div class="col-6 image-section position-relative">
            <div class="mt-2">
                <div class="d-flex justify-content-between flex-column align-items-center">
                    <apnst-material-stepper [steps]="steps" class="mb-6"></apnst-material-stepper>
                    <img class="img img-fluid " src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718188677929Frame%201000002351%20%283%29.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-primary-faint mb-3">
                        <div class="col-1 faq-primary-div-height mt-n2">
                            <h6 class="rotate-text text-center mt-5 py-2">FAQ</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718190108116Marks%201%20%282%29.png" alt="">
                            </div>

                            <div class="w-100 mt-1">
                                <h6>Can a friend be a co-applicant for an education loan?</h6>
                                <p class="fs-8">Yes, a co-applicant can be a family member or friend with a good CIBIL score and income, willing to share loan repayment responsibility.</p>
                            </div>
                        </div>
                    </div>

                    <div class="row align-items-center mx-2 bg-light border-primary-faint">
                        <div class="col-1 faq-primary-div-height mt-n2 mt-md-n3">
                            <h6 class="rotate-text text-center mt-4 py-3">NOTE</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718190108116Marks%201%20%282%29.png" alt="">
                            </div>
                            <div class="w-100 mt-1">
                                <h6 class="fs-lg-none fs-7 fw-bold">What factors are considered by lenders regarding co-applicants?</h6>
                                <p class="fs-8 fs-lg-7 mt-md-n1">Lenders consider the CIBIL score, income proof (ITR, salary slips, financial documents), and annual income to assess credit worthiness and financial stability for loan approval.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6">
            <div class="container overflow-hidden">
                <div>
                    <apnst-common-header [configHeader]="configNonCollateralDetailsHeader" [showHeaderWeb]="true" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
                </div>
                <aerp-base-schema-form [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmitResponse)="onSubmit($event)" [layout]="layout">
                </aerp-base-schema-form>
            </div>

        </div>
    </div>
</div>

<div class="d-lg-none d-block">
    <div class="container">
        <div class="fixed-header">
            <div class="mt-5">
                <apnst-material-stepper [steps]="steps"></apnst-material-stepper>
            </div>
            <apnst-common-header [configHeader]="configNonCollateralDetailsHeader" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
        </div>

        <div class="scrollable-content mb-4">
            <aerp-base-schema-form [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmitResponse)="onSubmit($event)" [layout]="layout">
            </aerp-base-schema-form>
        </div>
    </div>
</div>